import React, { PropTypes } from "react";

export default function ShippingView({ children }) {
    return (
      <tbody>
        {children}
      </tbody>
    );
}
ShippingView.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Views/ShippingView.jsx